import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "batchplaycommandoptions"
    }}>{`BatchPlayCommandOptions`}</h1>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <h3 {...{
      "id": "commandenablement"
    }}>{`commandEnablement`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`Optional`}</inlineCode>{` `}<strong parentName="p">{`commandEnablement`}</strong>{`: `}<inlineCode parentName="p">{`"normal"`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="p">{`"never"`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="p">{`"always"`}</inlineCode></p>
    <hr></hr>
    <h3 {...{
      "id": "dialogoptions"
    }}>{`dialogOptions`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`Optional`}</inlineCode>{` `}<strong parentName="p">{`dialogOptions`}</strong>{`: `}<inlineCode parentName="p">{`"silent"`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="p">{`"dontDisplay"`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="p">{`"display"`}</inlineCode></p>
    <hr></hr>
    <h3 {...{
      "id": "historystateinfo"
    }}>{`historyStateInfo`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`Optional`}</inlineCode>{` `}<strong parentName="p">{`historyStateInfo`}</strong>{`: `}<em parentName="p">{`object`}</em></p>
    <h4 {...{
      "id": "type-declaration"
    }}>{`Type declaration`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`name`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`target`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`object`}</em></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "modalbehavior"
    }}>{`modalBehavior`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`Optional`}</inlineCode>{` `}<strong parentName="p">{`modalBehavior`}</strong>{`: `}<inlineCode parentName="p">{`"wait"`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="p">{`"execute"`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="p">{`"fail"`}</inlineCode></p>
    <hr></hr>
    <h3 {...{
      "id": "propagateerrortodefaulthandler"
    }}>{`propagateErrorToDefaultHandler`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`Optional`}</inlineCode>{` `}<strong parentName="p">{`propagateErrorToDefaultHandler`}</strong>{`: `}<em parentName="p">{`boolean`}</em></p>
    <hr></hr>
    <h3 {...{
      "id": "suppressplaylevelincrease"
    }}>{`suppressPlayLevelIncrease`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`Optional`}</inlineCode>{` `}<strong parentName="p">{`suppressPlayLevelIncrease`}</strong>{`: `}<em parentName="p">{`boolean`}</em></p>
    <hr></hr>
    <h3 {...{
      "id": "synchronousexecution"
    }}>{`synchronousExecution`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`Optional`}</inlineCode>{` `}<strong parentName="p">{`synchronousExecution`}</strong>{`: `}<em parentName="p">{`boolean`}</em></p>
    <hr></hr>
    <h3 {...{
      "id": "usemultiget"
    }}>{`useMultiGet`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`Optional`}</inlineCode>{` `}<strong parentName="p">{`useMultiGet`}</strong>{`: `}<em parentName="p">{`boolean`}</em></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      